import { useStoreConfig } from '~/store/storeConfig'

export default function (languageId: number | null): string | null {
  const site = useStoreConfig().getSite
  const currentLanguage = site?.languages?.find((predicate) => predicate.id === languageId)

  return currentLanguage?.pivot?.live_agent_id ?? null
}
